// bfs-cart-watcher.js
// Global watcher: whenever anything adds to cart via /cart/add.js,
// refresh the cart drawer sections + open the drawer.
// Does NOT modify product logic, variant logic, or button behaviour.

(function () {
  if (window.__BFS_CART_WATCHER_BOUND__) return;
  window.__BFS_CART_WATCHER_BOUND__ = true;

  var refreshTimer = null;

  function refreshAndOpenDrawer() {
    fetch('/cart?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        document.dispatchEvent(
          new CustomEvent('cart:refresh', { detail: { id: null, sections: sections } })
        );
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function (err) {
        console.error('[BFS cart watcher] refresh failed:', err);
      });
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshAndOpenDrawer, 350);
  }

  function runChecks() {
    window.__bfsKingMattressCheckAfterAdd && window.__bfsKingMattressCheckAfterAdd();
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var url = args && args[0];
      var urlStr = '';
      try {
        urlStr = typeof url === 'string' ? url : (url && url.url) ? url.url : '';
      } catch (e) {}

      return originalFetch.apply(this, args).then(function (response) {
        if (urlStr && urlStr.indexOf('/cart/add') !== -1) {
          if (response && response.ok) {
            scheduleRefresh();
            runChecks();
          }
        }
        return response;
      });
    };
  }

  var OriginalXHR = window.XMLHttpRequest;
  if (OriginalXHR) {
    function PatchedXHR() {
      var xhr = new OriginalXHR();
      var _open = xhr.open;
      xhr.open = function (method, url) {
        xhr.__bfs_url = url;
        return _open.apply(xhr, arguments);
      };
      xhr.addEventListener('load', function () {
        try {
          var url = xhr.__bfs_url || '';
          if (url && url.indexOf('/cart/add') !== -1) {
            if (xhr.status >= 200 && xhr.status < 300) {
              scheduleRefresh();
              runChecks();
            }
          }
        } catch (e) {}
      });
      return xhr;
    }
    window.XMLHttpRequest = PatchedXHR;
  }
})();

// ============================================================
// BFS shared toast styling (used by the prompt below)
// Injected once, guarded so it's never duplicated.
// ============================================================
(function () {
  if (window.__BFS_TOAST_STYLES_INJECTED__) return;
  window.__BFS_TOAST_STYLES_INJECTED__ = true;

  var style = document.createElement('style');
  style.textContent =
    '.bfs-toast{position:fixed;z-index:99999;max-width:360px;width:calc(100% - 40px);' +
    'background:linear-gradient(180deg,#FFFDFB 0%,#FBF4EC 100%);border:1px solid #ECDFD1;' +
    'border-radius:18px;padding:20px 20px 18px;box-shadow:0 20px 40px -10px rgba(68,58,53,.35),0 2px 8px rgba(68,58,53,.08);' +
    'font-family:Karla,sans-serif;display:none;opacity:0;transform:translateY(16px);' +
    'transition:opacity .35s ease,transform .35s ease;box-sizing:border-box;}' +
    '.bfs-toast.is-visible{display:block;}' +
    '.bfs-toast.is-shown{opacity:1;transform:translateY(0);}' +
    '.bfs-toast__accent{position:absolute;top:0;left:20px;right:20px;height:3px;border-radius:0 0 3px 3px;' +
    'background:linear-gradient(90deg,#8B1E1E,#C9601F);}' +
    '.bfs-toast__close{position:absolute;top:12px;right:12px;width:26px;height:26px;border:none;' +
    'background:rgba(68,58,53,.06);border-radius:50%;color:#8A7A6C;cursor:pointer;display:flex;' +
    'align-items:center;justify-content:center;font-size:15px;line-height:1;padding:0;transition:background .15s ease;}' +
    '.bfs-toast__close:hover{background:rgba(68,58,53,.14);}' +
    '.bfs-toast__header{display:flex;align-items:center;gap:10px;margin:2px 26px 12px 0;}' +
    '.bfs-toast__icon{flex:0 0 auto;width:38px;height:38px;border-radius:10px;background:#F1E4D4;' +
    'display:flex;align-items:center;justify-content:center;}' +
    '.bfs-toast__eyebrow{font-weight:800;font-size:10.5px;letter-spacing:.07em;text-transform:uppercase;' +
    'color:#8B1E1E;background:#FBE7E3;padding:4px 9px;border-radius:999px;display:inline-block;}' +
    '.bfs-toast__title{margin:0 0 12px;font-size:14.5px;font-weight:800;color:#2E2622;line-height:1.35;}' +
    '.bfs-toast__price-row{display:flex;align-items:baseline;gap:8px;margin:0 0 16px;}' +
    '.bfs-toast__price-was{font-size:13px;color:#A99A8C;text-decoration:line-through;}' +
    '.bfs-toast__price-now{font-size:23px;font-weight:900;color:#2E2622;}' +
    '.bfs-toast__save{font-size:11px;font-weight:800;color:#3F7D4A;background:#E4F3E6;padding:3px 9px;' +
    'border-radius:999px;margin-left:auto;white-space:nowrap;}' +
    '.bfs-toast__cta{width:100%;background:#2E2622;color:#fff;border:none;padding:13px 16px;' +
    'border-radius:999px;cursor:pointer;font-weight:800;font-size:12px;letter-spacing:.05em;' +
    'text-transform:uppercase;transition:transform .15s ease,background .15s ease;}' +
    '.bfs-toast__cta:hover{background:#443A35;transform:translateY(-1px);}' +
    '.bfs-toast__cta:disabled{opacity:.6;cursor:default;transform:none;}' +
    '@media (max-width:480px){.bfs-toast{left:12px;right:12px;bottom:12px;max-width:none;width:auto;}' +
    '.bfs-toast--left{left:12px;}}';
  document.head.appendChild(style);
})();

function bfsShowToast(el) {
  el.classList.add('is-visible');
  requestAnimationFrame(function () {
    requestAnimationFrame(function () { el.classList.add('is-shown'); });
  });
}

function bfsHideToast(el) {
  if (!el) return;
  el.classList.remove('is-shown');
  setTimeout(function () { el.classList.remove('is-visible'); }, 320);
}

// Multi-option variants come through as "King / 60" Floor Standing / Divan + Ottoman",
// so compare only the first (Size) segment rather than the whole title.
function bfsSizeOf(item) {
  return String(item.variant_title || '').split('/')[0].trim().toLowerCase();
}

// The King bed + King mattress matching storage box prompt (£50) was
// discontinued on 12 Oct 2026 and has been removed from this file.

// ============================================================
// BFS King Bed + Ezra Majestic 1000 King Mattress Prompt (King Bed Offer)
// The offer mattress is its own hidden product, priced at 30% off the standard
// King mattress and tagged bfs10-excluded (no discount involved, so BFS10 still
// takes 10% off the bed). This block does two jobs:
//   1. Prompt: when a King bed from the offer is in the cart and NO King
//      mattress is, show a bottom-right toast to add the offer mattress.
//   2. Guard: the offer mattress is only valid with a King bed, one per King
//      bed. Any offer mattresses beyond the number of King beds are removed.
// Prices are read live from the offer product (price / compare-at).
// ============================================================
(function () {
  if (window.__BFS_KING_MATTRESS_PROMPT_BOUND__) return;
  window.__BFS_KING_MATTRESS_PROMPT_BOUND__ = true;

  var OFFER_VARIANT_ID = 58715718189387; // Ezra Majestic 1000 King Mattress (King Bed Offer)
  var OFFER_HANDLE = 'ezra-majestic-1000-king-mattress-king-bed-offer';
  var SESSION_KEY = 'bfs_king_mattress_offer_dismissed';

  // The 61 beds in the King Sized Beds collection that the offer covers.
  var KING_OFFER_PRODUCT_IDS = [
    15855676358987, 15635516948811, 15855684845899, 15855687893323, 15855687860555, 15855687795019,
    15855687762251, 15855687696715, 15855686877515, 15855686844747, 15855686811979, 15855686779211,
    15855686746443, 15855686451531, 15855686418763, 15855686385995, 15855686353227, 15855686320459,
    15855685861707, 15855685828939, 15855685796171, 15855685763403, 15855685730635, 15855684911435,
    15855684878667, 15855684813131, 15855684780363, 15855683731787, 15855683699019, 15855683666251,
    15855683600715, 15855683535179, 15855682879819, 15855682847051, 15855682814283, 15855682781515,
    15855682748747, 15855681732939, 15855681700171, 15855681667403, 15855681634635, 15855681601867,
    15855676457291, 15807261376843, 15694105510219, 15644293235019, 15644281274699, 15644273246539,
    15644259320139, 15615895208267, 15588051681611, 15522264842571, 15521691500875, 15521657192779,
    15521527136587, 15518487118155, 15518479089995, 15518475944267, 15518451204427, 15518202364235,
    15518085808459
  ];

  var KING_MATTRESS_HANDLES = [
    'nehemiah-grand-memory-foam-pillow-top-mattress', 'remel-supreme-2000-pocket-spring-back-support-mattress',
    'pauline-majestic-1000-pocket-spring-pillow-top-mattress', 'ezra-majestic-1000-pocket-spring-back-support-mattress',
    'rhianna-grand-memory-foam-back-support-mattress', 'eva-essential-pillow-top-mattress',
    'eva-essential-back-support-mattress', 'mia-bella-open-coil-sprung-mattress',
    'salome-aloe-vera-memory-sprung-orthopaedic-mattress'
  ];

  var BED_ICON =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8B1E1E" stroke-width="1.8" ' +
    'stroke-linecap="round" stroke-linejoin="round"><path d="M3 18V8"/><path d="M21 18v-5a2 2 0 0 0-2-2H3"/>' +
    '<path d="M3 15h18"/><path d="M7 11V9.5A1.5 1.5 0 0 1 8.5 8h2A1.5 1.5 0 0 1 12 9.5V11"/></svg>';

  var toastEl = null;
  var priceWas = 46069; // pence, refreshed from the offer product below
  var priceNow = 32249;

  function money(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  function loadPrice() {
    return fetch('/products/' + OFFER_HANDLE + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;
        var v = p.variants[0];
        OFFER_VARIANT_ID = v.id;
        priceNow = v.price;
        if (v.compare_at_price && v.compare_at_price > v.price) priceWas = v.compare_at_price;
      })
      .catch(function () {});
  }

  function savePct() {
    return Math.round((1 - priceNow / priceWas) * 100);
  }

  function buildToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.id = 'bfs-king-mattress-upsell';
    toastEl.className = 'bfs-toast';
    toastEl.style.bottom = '20px';
    toastEl.style.right = '20px';

    toastEl.innerHTML =
      '<button type="button" class="bfs-toast__close" aria-label="Close">&times;</button>' +
      '<div class="bfs-toast__accent"></div>' +
      '<div class="bfs-toast__header">' +
        '<div class="bfs-toast__icon">' + BED_ICON + '</div>' +
        '<span class="bfs-toast__eyebrow">King Bed Offer</span>' +
      '</div>' +
      '<p class="bfs-toast__title">Complete your King bed: Ezra Majestic 1000 Pocket Sprung Mattress, delivered with your bed frame</p>' +
      '<div class="bfs-toast__price-row">' +
        '<span class="bfs-toast__price-was">' + money(priceWas) + '</span>' +
        '<span class="bfs-toast__price-now">' + money(priceNow) + '</span>' +
        '<span class="bfs-toast__save">' + savePct() + '% off</span>' +
      '</div>' +
      '<button type="button" id="bfs-add-king-mattress-btn" class="bfs-toast__cta">Add for ' + money(priceNow) + '</button>';

    document.body.appendChild(toastEl);

    toastEl.querySelector('.bfs-toast__close').addEventListener('click', function (e) {
      e.preventDefault();
      sessionStorage.setItem(SESSION_KEY, '1');
      bfsHideToast(toastEl);
    });

    toastEl.querySelector('#bfs-add-king-mattress-btn').addEventListener('click', function (e) {
      e.preventDefault();
      var btn = e.target;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{
          id: OFFER_VARIANT_ID,
          quantity: 1,
          properties: { 'Size': 'King', 'Offer': '30% off with King bed', 'Delivery': 'Arrives with your bed frame' }
        }] })
      }).then(function (res) {
        if (res.ok) {
          window.location.reload();
        } else {
          btn.disabled = false;
          btn.textContent = 'Add for ' + money(priceNow);
        }
      });
    });

    return toastEl;
  }

  // Guard: never more offer mattresses than King beds. Trims the newest
  // offer lines first and reloads so totals and drawers are correct.
  function enforceLimit(cart, kingBeds) {
    var offerLines = (cart.items || []).filter(function (item) { return item.handle === OFFER_HANDLE; });
    var offerQty = offerLines.reduce(function (n, item) { return n + item.quantity; }, 0);
    var excess = offerQty - kingBeds;
    if (excess <= 0) return Promise.resolve(false);
    var updates = {};
    for (var i = 0; i < offerLines.length && excess > 0; i++) {
      var line = offerLines[i];
      var cut = Math.min(line.quantity, excess);
      updates[line.key] = line.quantity - cut;
      excess -= cut;
    }
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (res.ok) window.location.reload();
      return true;
    }).catch(function () { return false; });
  }

  function checkCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var kingBeds = 0;
        var hasKingMattress = false;
        (cart.items || []).forEach(function (item) {
          if (KING_OFFER_PRODUCT_IDS.indexOf(item.product_id) !== -1 && bfsSizeOf(item) === 'king') {
            kingBeds += item.quantity;
          }
          if (item.handle === OFFER_HANDLE ||
              (KING_MATTRESS_HANDLES.indexOf(item.handle) !== -1 && bfsSizeOf(item) === 'king')) {
            hasKingMattress = true;
          }
        });
        return enforceLimit(cart, kingBeds).then(function (changed) {
          if (changed) return;
          if (kingBeds > 0 && !hasKingMattress && !sessionStorage.getItem(SESSION_KEY)) {
            loadPrice().then(function () { bfsShowToast(buildToast()); });
          } else {
            bfsHideToast(toastEl);
          }
        });
      })
      .catch(function (err) {
        console.error('[BFS King mattress prompt] cart check failed:', err);
      });
  }

  // Debounced: when the configurator adds the mattress straight after the bed,
  // wait for both adds to land so the toast doesn't flash up in between.
  var checkTimer = null;
  window.__bfsKingMattressCheckAfterAdd = function () {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(checkCart, 900);
  };

  // Removing a bed from the cart page / drawer goes through /cart/change or
  // /cart/update, which the main watcher doesn't track, so re-check on those too.
  var prevFetch = window.fetch;
  if (typeof prevFetch === 'function') {
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var p = prevFetch.apply(this, arguments);
      if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
        p.then(function (res) { if (res && res.ok) window.__bfsKingMattressCheckAfterAdd(); });
      }
      return p;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkCart);
  } else {
    checkCart();
  }
})();
